import { render, staticRenderFns } from "./TransferToAfropayModal2.vue?vue&type=template&id=6e05a568&scoped=true&"
import script from "./TransferToAfropayModal2.vue?vue&type=script&lang=js&"
export * from "./TransferToAfropayModal2.vue?vue&type=script&lang=js&"
import style0 from "./TransferToAfropayModal2.vue?vue&type=style&index=0&id=6e05a568&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e05a568",
  null
  
)

export default component.exports